import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectPictureInPictureId } from "plugins/shared/playback/state/selectors"
import { useVideoControllerForFlight } from "../controllers/hooks/useController"
import { zoomToShowPoints } from "features/map/zoom/thunks"

export const useZoomToPipFlight = () => {
    const dispatch = useAppDispatch()
    const pipId = useAppSelector(selectPictureInPictureId)
    const pipFlightVideoController = useVideoControllerForFlight({ flightId: pipId ?? "" })
    const zoomTo = () => {
        if (!pipFlightVideoController) return
        const points = pipFlightVideoController.getAllCoords()
        const cleanPoints = points.filter((p) => !!p.lat && !!p.lng)
        if (cleanPoints.length) {
            dispatch(
                zoomToShowPoints({ points: cleanPoints.map((p) => [p.lng, p.lat]), padding: 20 })
            )
        }
    }
    return {
        zoomTo,
        readyToZoom: !!pipFlightVideoController,
    }
}
